import { SuppliesSiteApi } from '@wiz-api/emergency-management'

import { map, forEach, find, concat, isEmpty, reduce, filter } from 'lodash'

const suppliesSiteApi = new SuppliesSiteApi()

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}
/** ************************************************ 物资列表 **************************************** */
// 物资绘制实例列表
let suppliesInstance = []
// 物资列表
let suppliesList = []
// 图标列表
const suppliesIconList = []

let cloudRender

// 初始化数据
const initRouteData = () => {
  suppliesInstance = []
  suppliesList = []
  // 图标列表
  suppliesIconList.length = 0
}

// 获取当前场景物资列表
const getSuppliesList = async (sceneId) => {
  const params = {
    skipCount: 0,
    maxResultCount: 999,
    sceneId,
  }
  const [err, data] = await suppliesSiteApi.getSiteSceneList({ body: params })
  if (!err) {
    const isDrawlist = filter(data.items, (item) => {
      return item.isDrawStr === '是'
    })
    return isDrawlist
  }
  return []
}
// 根据区域获取列表数据
const getListByArea = async (areaId) => {
  const params = {
    skipCount: 0,
    maxResultCount: 999,
    areaId,
    isDraw: true,
  }
  const [err, data] = await suppliesSiteApi.getList(params)
  if (!err) {
    return data.items
  }
  return []
}

// 绘制标签
const drawMarker = async (player, detail) => {
  if (!player.Native) return

  const pos = [+detail.pointX, +detail.pointY, +detail.pointZ]
  const singleOption = {
    id: `${getUUID()}_supplies`,
    pos,
    background: 'buildFloor',
    visible: true,
    nodeOffset: [0, 0],
    text: '应急物资',
    textColor: '#ffffffff',
    hasTriangle: true,
    markPosType: 4,
  }
  // 文字
  const res = await cloudRender.Marker.createBySingleLine(singleOption)
  if (res.status) {
    const data = map(res.data, (item) => {
      return {
        id: item,
        dataId: detail.id,
        type: 'single',
        codeStr: detail.suppliesSiteCodeStr,
        suppliesSite: detail.suppliesSite,
        pos,
      }
    })
    suppliesIconList.push(...data)
  }
}
// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const areaInfo = find(suppliesIconList, (item) => {
      return item.id === e.markerId
    })
    if (areaInfo) {
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row: { ...areaInfo, id: areaInfo.dataId },
          type: 'emergencyMatter',
        },
      })
      window.dispatchEvent(openEvent)
    }
  }
}

// 创建物资
const create = async (player, sourceId, propCloudRender, areaId) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initRouteData()
  cloudRender = propCloudRender
  window.cloudRender = cloudRender
  // 获取物资列表数据
  suppliesList = await getSuppliesList(sourceId, areaId)

  // 生成物资
  for (let i = 0; i < suppliesList.length; i += 1) {
    const item = suppliesList[i]
    await drawMarker(player, item)
  }
  cloudRender.Dispatch.on('Marker', markerClick)
}

// 销毁
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(suppliesIconList, 'id'))
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}

// 更新物资显隐（区域改变）
const update = async (player, sourceId, propCloudRender, areaId) => {
  if (!player.Native) {
    return
  }
  // 获取新的物资列表数据

  if (areaId) {
    const newList = await getListByArea(areaId)
    const newCodes = map(newList, (i) => {
      return i.codeStr
    })
    // 更新物资标签显隐
    const iconInstanceToUpdate = reduce(
      suppliesIconList,
      (acc, item) => {
        const action = newCodes.includes(item.codeStr) ? 'show' : 'hide'
        acc[action].push(item)
        return acc
      },
      { hide: [], show: [] }
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.hide, (i) => {
        return {
          id: i.id,
          visible: false,
        }
      })
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.show, (i) => {
        return {
          id: i.id,
          visible: true,
        }
      })
    )
  } else {
    // 清空区域id 显示全部
    cloudRender.Marker.updateBySingleLine(
      map(suppliesIconList, (i) => {
        return {
          id: i.id,
          visible: true,
        }
      })
    )
  }
}

export { suppliesIconList }
export default { create, destroy, update }
